import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MobileHeaderProps {
    title: string;
    showBack?: boolean;
    backPath?: string;  // Optional specific path for back button, otherwise uses navigate(-1)
    rightAction?: React.ReactNode;
    className?: string;
}

export function MobileHeader({
    title,
    showBack = false,
    backPath,
    rightAction,
    className
}: MobileHeaderProps) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (backPath) {
            navigate(backPath);
        } else {
            navigate(-1);
        }
    };

    return (
        <>
            {/* Fixed header - background extends into safe area */}
            <header className={cn('mobile-header', className)}>
                <div className="flex items-center justify-between h-12 px-4">
                    {/* Left side - back button or spacer */}
                    <div className="w-10 flex items-center">
                        {showBack && (
                            <button
                                onClick={handleBack}
                                className="flex items-center justify-center w-10 h-10 -ml-2 rounded-full active:bg-accent"
                            >
                                <ChevronLeft className="h-6 w-6" />
                            </button>
                        )}
                    </div>

                    {/* Center - title */}
                    <h1 className="text-lg font-semibold truncate flex-1 text-center">
                        {title}
                    </h1>

                    {/* Right side - action or spacer */}
                    <div className="w-10 flex items-center justify-end">
                        {rightAction}
                    </div>
                </div>
            </header>
            {/* Spacer - matches header height including safe area */}
            <div
                className="shrink-0"
                style={{ height: 'calc(env(safe-area-inset-top, 0px) + 3rem)' }}
            />
        </>
    );
}
